<template>
  <div>
    <a-row>
      <g-master name="Objetivos"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :parentData="parentData"
                modalWidth="100%"
                ref="master"
      >
        <template slot="expandedRowRender" slot-scope="{text}">
          <template v-for="ve in master.valoresExpandidos">
            {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
          </template>
        </template>
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-divider>RESPONSABILIDAD Y OBJETIVO A TRABAJAR</a-divider>
            <a-col v-bind="colOptions1">
              <a-form-item v-bind="fiOptions" :label="$t('Responsabilidades Claves')">
                <a-textarea autoSize
                            v-decorator="['responsibilities', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                />
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions1">
              <a-form-item v-bind="fiOptions" :label="$t('Objetivos del Cargo')">
                <a-textarea autoSize
                            v-decorator="['objectives', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-divider>PLAN DE ACCIÓN</a-divider>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Actividades')">
                <a-textarea autoSize
                            v-decorator="['action_plan_activities', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item label="Fecha Inicio" v-bind="fiOptions">
                <a-date-picker style="width: 100%" valueFormat="Y-MM-DD 00:00:00"
                               v-decorator="['start_date_plan_activities', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item label="Fecha Terminación" v-bind="fiOptions">
                <a-date-picker style="width: 100%" valueFormat="Y-MM-DD 00:00:00"
                               v-decorator="['end_date_plan_activities', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
              </a-form-item>
            </a-col>
            <a-divider>INDICADOR, META Y PONDERACIÓN</a-divider>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Indicadores de cumplimiento de actividades')">
                <a-textarea autoSize
                            v-decorator="['activity_compliance_indicators', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Meta del Indicador - Porcentaje ')">
                <a-input style="width: 100%"
                         v-decorator="['percentage_indicator', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Meta del Indicador - Fecha')">
                <a-date-picker style="width: 100%" valueFormat="Y-MM-DD 00:00:00"
                               v-decorator="['date_indicator', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Ponderación (60 puntos)')">
                <a-input style="width: 100%"
                         v-decorator="['weighing', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="Seguimiento" key="1">
          <eva_seguimiento v-if="idSeleccionado" :id_objective="idSeleccionado"></eva_seguimiento>
          <span v-else>Seleccione una objetivo para ver más.</span>
        </a-tab-pane>

        <a-tab-pane tab="Resultados Finales" key="2">
          <eva_resultados_finales v-if="idSeleccionado && idEmpSeleccionado" :id_objective="idSeleccionado"
                                  :id_emp="idEmpSeleccionado"></eva_resultados_finales>
          <span v-else>Seleccione una objetivo para ver más.</span>
        </a-tab-pane>

      </a-tabs>
    </a-row>
  </div>
</template>

<script>
  export default {
    props: ['id_emp'],
    data () {
      return {
        selOptions: {
          allowClear: true
        },
        colOptions: {xs: 24, sm: 6},
        colOptions1: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'eva_objetivos',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            allowSelect: true,
            selectedRows: [],
            columns: [
              {
                title: 'Responsabilidades Claves (Cartas Descriptivas)',
                dataIndex: 'responsibilities',
                align: 'center',
                sorter: true,
                width: 250
              },
              {title: 'Objetivos del cargo', align: 'center', dataIndex: 'objectives', sorter: true, width: 200},
              {
                title: 'Plan de acción',
                align: 'center',
                children: [
                  {title: 'Actividad', dataIndex: 'action_plan_activities', align: 'center', sorter: true, width: 250},
                  {title: 'Fecha Inicio', dataIndex: 'desc_start_date_plan_activities', align: 'center', sorter: true},
                  {title: 'Fecha Fin', dataIndex: 'desc_end_date_plan_activities', align: 'center', sorter: true}
                ]
              },
              {
                title: 'Indicadores de cumplimiento de las actividades',
                dataIndex: 'activity_compliance_indicators',
                align: 'center',
                sorter: true,
                width: 250
              },
              {
                title: 'Porcentaje de meta del indicador (%)',
                dataIndex: 'percentage_indicator',
                align: 'center',
                sorter: true,
                width: 150
              },
              {title: 'Fecha de meta indicador', dataIndex: 'desc_date_indicator', align: 'center', sorter: true, width: 150},
              {title: 'Ponderación de indicadores (60 puntos)', dataIndex: 'weighing', align: 'center', sorter: true, width: 180}
            ]
          },
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ]
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_emp: this.id_emp
        }
      },
      idSeleccionado () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      },
      idEmpSeleccionado () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id_emp : null
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Evaluaciones/Complemento/Objetivos.vue